/**
 * @file The upload import tasks action
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ActionBase } from '../action';
/**
 * @file Upload and import tasks action
 * @author Heino Lenting
 */
var UploadImportTasksAction = /** @class */ (function (_super) {
    tslib_1.__extends(UploadImportTasksAction, _super);
    /**
     * Creates an instance of UploadImportTasksAction.
     * @param {FileReaderService} fileReaderService
     * @param {string} icon
     * @param {string} labelKey
     */
    function UploadImportTasksAction(fileReaderService) {
        var _this = _super.call(this, 'sym-icon-upload', 'APP.MISC.UPLOAD_AND_IMPORT') || this;
        _this.fileReaderService = fileReaderService;
        /**
        * The success labelkey
        */
        _this.successLabelKey = 'APP.LISTS.ACTION_UPLOAD_IMPORT_TASKS_SUCCESS';
        return _this;
    }
    /**
     * Execute the action
     * @param {ActionConfiguration} actionConfiguration The action configuration
     */
    UploadImportTasksAction.prototype.do = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fileData, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.fileReaderService.pickFile(['text/xml'], '.xml')];
                    case 1:
                        fileData = _a.sent();
                        if (!fileData) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fileReaderService.uploadFile('upload', fileData, true)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(this.successLabelKey)];
                    case 3: 
                    // The user may have cancelled the dialog form. Then resolve with an empty message.
                    return [2 /*return*/, Promise.resolve()];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        return [2 /*return*/, Promise.reject({ labelKey: 'APP.LISTS.ACTION_FAILED', message: error_1 })];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return UploadImportTasksAction;
}(ActionBase));
export { UploadImportTasksAction };
